/**
 * Front-end behavior for Callout Text (scoped to block instances).
 */
export class CalloutTextFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="callout-text"]' ).forEach( ( el ) => {
			el.classList.add( 'callout-text-enhanced' );
		} );
	}
}
